export class PromiseQueue {
  queue = Promise.resolve(true);
  pendingCount = 0;
  bufferLimit;
  cancelled = false;

  constructor(bufferLimit) {
    this.bufferLimit = bufferLimit;
  }

  add(operation) {
    if (this.pendingCount >= this.bufferLimit) {
      return Promise.reject(new Error("Buffer limit reached."));
    }

    this.pendingCount++;

    return new Promise((resolve, reject) => {
      this.queue = this.queue
        .then(() => {
          // A cancelled queue skips tasks that have not started yet, so
          // their closures (and anything large they captured) are released
          // as the chain drains instead of running to no purpose.
          if (this.cancelled) {
            return Promise.reject(new Error("Queue cancelled."));
          }
          return operation();
        })
        .then((res) => {
          this.pendingCount--;
          resolve(res);
        })
        .catch((err) => {
          this.pendingCount--;
          reject(err);
        });
    });
  }

  // Skip every task that has not started yet. The task currently running
  // is not interrupted.
  cancelPending() {
    this.cancelled = true;
  }

  async allSettled(timeoutMilliseconds = -1) {
    const tasks = [Promise.allSettled([this.queue])];
    let timeoutHandle;
    if (timeoutMilliseconds >= 0) {
      tasks.push(new Promise((resolve) => {
        timeoutHandle = setTimeout(resolve, timeoutMilliseconds);
      }));
    }
    try {
      await Promise.race(tasks);
    } finally {
      // Clear the timer if the queue drained first, so it does not stay
      // pending and keep the event loop alive during teardown.
      clearTimeout(timeoutHandle);
    }
  }

  getPendingLength() {
    return this.pendingCount;
  }
}
